import { ThumbsDownFilled, ThumbsUpFilled } from '@heidi/design-system/feedback-thumbs';
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from '@heidi/design-system/tooltip';
import { cn } from '@heidi/utils';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { type ComponentProps } from 'react';
import { useIntl } from 'react-intl';

interface ThumbsTooltipButtonProps extends ComponentProps<'button'> {
  variant: 'up' | 'down';
  selected: boolean;
  size?: number; // pixels
}

const THUMB_ICONS = {
  up: { outline: ThumbsUp, filled: ThumbsUpFilled },
  down: { outline: ThumbsDown, filled: ThumbsDownFilled },
} as const;

export function ThumbsTooltipButton({
  className,
  selected,
  variant,
  size = 12,
  disabled,
  ...props
}: ThumbsTooltipButtonProps) {
  const intl = useIntl();
  const Icon = THUMB_ICONS[variant][selected ? 'filled' : 'outline'];
  return (
    <button
      disabled={disabled}
      aria-pressed={selected}
      className={cn(
        'size-fit rounded-md p-1 transition hover:bg-surface-hover',
        disabled && 'cursor-not-allowed',
        className
      )}
      {...props}
    >
      <Tooltip>
        <TooltipTrigger asChild disabled={disabled}>
          <div className="flex aspect-square size-3 items-center justify-center">
            <Icon size={size} className="text-text-secondary" />
          </div>
        </TooltipTrigger>
        <TooltipContent>
          {variant === 'up'
            ? intl.formatMessage({ id: 'QccvNzp5li', defaultMessage: 'Good Response' })
            : intl.formatMessage({ id: 'bk1oX0v1WW', defaultMessage: 'Bad Response' })}
          <TooltipArrow className="scale-110" />
        </TooltipContent>
      </Tooltip>
    </button>
  );
}
